import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const MessagePage: FC = () => {  
    return (
        <Outlet />
    );
}

export default MessagePage